import nullPeriod from "../../period/nullPeriod.js";
import PeriodReport from "./PeriodReport.js";

let instance;

/**
 * `NullPeriodReport` is a Null Object pattern implementation of
 * `PeriodReport`. Use the static method `instance()` to access its
 * unique instance.
 */
export default class NullPeriodReport extends PeriodReport {
	isNull() {
		return true;
	}

	isPublished() {
		return false;
	}

	isDraft() {
		return false;
	}

	isWithdrawn() {
		return false;
	}

	withdraw() {
		throw new Error("Cannot withdraw a null period report");
	}

	delete() {
		throw new Error("Cannot delete a null period report");
	}

	getPeriod() {
		return nullPeriod;
	}

	getKeyFigures() {
		return [];
	}

	getAttachments() {
		return [];
	}

	getLastUpdateDate() {
		return new Date();
	}

	getPublishDate() {
		return new Date();
	}

	getAuthor() {
		return "";
	}

	getCompany() {
		return null;
	}

	getTitle() {
		return "Null Report";
	}

	getSubtitle() {
		return "";
	}

	getComment() {
		return null;
	}

	getId() {
		return null;
	}

	getOverviewData() {
		return null;
	}

	getBalanceSheet() {
		return null;
	}

	getIncomeStatement() {
		return null;
	}

	isMonthReport() {
		return false;
	}

	isBimesterReport() {
		return false;
	}

	isQuarterReport() {
		return false;
	}

	isHalfYearReport() {
		return false;
	}

	isYearReport() {
		return false;
	}

	isConsecutiveMonthsReport() {
		return false;
	}

	hasComment() {
		return false;
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
